import axios from 'axios'
import {HOST} from "../config";
import { addSign } from "../utils/tools"
import { Toast } from 'vant';
import Store from '@/store'
import { appkey }  from '@/config';
import router from '@/router'

axios.defaults.timeout = 7000;
axios.defaults.baseURL = HOST;
axios.defaults.withCredentials = false;

//import config from '../config/index' // 路径配置
//import vm from '../main'
// 创建axios 实例
/*const service = axios.create({
    baseURL: config.baseURL, // api的base_url
    timeout: 5000 // 请求超时时间
})*/

const tip = msg => {
    Toast({
        type: 'text',
        message: msg,
        duration: 2000,
        forbidClick: true
    })
}

const errorHandler = (status, other) => {
    switch (status) {
        case 401:
            // toLogin()
            router.replace('/login')
            break
        // 403 token过期
        case 403:
            tip('登录过期，请重新登录')
            router.replace('/login')
            break
        // 404请求不存在
        case 404:
            tip('请求的资源不存在')
            break
        default:
            console.log(other)
    }
}
/**
 * codeMapping[业务错误码]
 * @return Boolean true -> code = 0
 */
const codeMapping = (data, isNeedTip) => {
    let result = true
    switch (data.code) {

        case 10105001002:
            isNeedTip && tip('登录状态失效，请重新登录')
            result = false
            // toLogin()
            break
        case 10105001006:
            isNeedTip && tip('登录状态失效，请重新登录')
            result = false
            break
        default:
            result = true
    }
    return result
}
const instance = axios.create({
    baseURL: `${HOST}`,
    timeout: 1000 * 120,
})

instance.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

// request 拦截器
instance.interceptors.request.use(
    config => {
      !window.navigator.onLine?tip('网络断开，请检查网络'):'';
      let token = Store.state.user.user.token || '';

        if (token){
            config.headers.Authorization = 'Bearer '+ token;
        } else {
            router.replace('/login')
        }
        config.headers.appkey = appkey;
        let g7_id = Store.state.user.user.id || '';
        //X-G7-Api-Uid
        if (g7_id){
            config.headers['X-G7-Api-Uid'] = g7_id;
        }
        // 这里可以自定义一些config 配置
        /*config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        config.headers.timestamp = Math.floor(new Date().getTime() / 1000)
        config.headers.token = sessionStorage.getItem('token') || ''
        // 接口没返回时显示loading
        if (config.loading === true) {
            vm.$loading.show()
        }*/
        if (config.method === 'post'){
            config.data = addSign(config.data);
        }

        return config
    },
    error => {
        //  这里处理一些请求出错的情况
       // vm.$loading.hide()
        Promise.reject(error)
    }
)

// response 拦截器
instance.interceptors.response.use(
    response => {
        let _result
        const { data, request } = response;
        /*if (request.responseURL.indexOf('refundApplyApi') !== -1) {
            _result = codeMapping(data, false)
        }*/

        _result = codeMapping(data, true)
        if (_result){
            return Promise.resolve(data)
        }else{
            //if(url.indexOf('login') > -1) return;

            if (localStorage.hasOwnProperty('g7user')){
                localStorage.removeItem('g7user')
            }
            router.replace('/login')
            return false
        }
        //const res = response.data
        // 这里处理一些response 正常放回时的逻辑
        // vm.$loading.hide()
        // return res
    },
    error => {
        // 这里处理一些response 出错时的逻辑
        // vm.$loading.hide()
        //return Promise.reject(error)
        const { response } = error
        if (response) {
            // 请求已发出，但是不在2xx的范围
            errorHandler(response.status, response.data.message || response.data.msg );
            return Promise.reject(response)
        } else {
            tip('网络已断开！')
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
            // store.commit('changeNetwork', false)
        }
    }
)

export default instance
